<template>
  <nav aria-label="breadcrumb">
    <ul class="breadcrumb">
      <li v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb-item">
        <template v-if="crumb.path">
          <router-link :to="crumb.path">{{ crumb.name }}</router-link>
        </template>
        <template v-else>
          <span>{{ crumb.name }}</span>
        </template>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  computed: {
    breadcrumbs() {
      const pathArray = this.$route.path.split('/').filter(Boolean);
      const breadcrumbs = pathArray.map((part, index) => {
        const path = '/' + pathArray.slice(0, index + 1).join('/');
        return {
          name: this.formatBreadcrumbName(part),
          path: index < pathArray.length - 1 ? path : null, // Only add a path for links before the last item
        };
      });
      return [{ name: "Home", path: "/" }, ...breadcrumbs];
    },
  },
  methods: {
    formatBreadcrumbName(part) {
      return part
        .replace(/-/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());
    },
  },
};
</script>

<style>
.breadcrumb {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 0.7rem; /* Smaller text */
  color: #aaa; /* Light grey */
}

.breadcrumb-item {
  margin-right: 0.5rem;
  font-size: 12px;
  color: #aaa;
}

.breadcrumb-item::after {
  content: "/";
  margin-left: 0.5rem;
  color: #aaa; /* Light grey for the separator */
}

.breadcrumb-item:last-child::after {
  content: "";
}

.breadcrumb-item  span,
.breadcrumb-item a {
  text-decoration: none;
  color: #aaa !important; /* Light grey for links */
  font-size: 11px;
}

.breadcrumb-item a:hover {
  text-decoration: none; /* No underline on hover */
}
</style>
